module.exports = __webpack_public_path__ + "static/media/13import-32.59e12cff.xlsx";